module.exports = __webpack_public_path__ + "img/card2.61642388.png";